<template>
  <button
      @click.prevent="addDevice()"
      class="btn--grey"
  >
    <span class="plus-icon">+</span> Voeg apparaat toe
  </button>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    addDevice() {
      this.$emit("on-new-device", {});
    }
  }
};
</script>

<style lang="scss" scoped>
.plus-icon {
  display: inline-block;
  border-radius: 9px;
  width: 18px;
  height: 18px;
  font-size: 22px;
  line-height: 18px;
  color: #FFF;
  background: #2f97da;
  margin-right: 10px;
}

.btn--grey {
  display: inline-flex;
  align-items: center;
  color: #808080;
  background-color: transparent;
  border: none;
}

</style>